import React, { useState } from "react";
import "../styles.css";
import { Button } from "@material-ui/core";
import "bootstrap/dist/css/bootstrap.min.css";

// List of props from Questions
// optionQuestion
// optionOne
// optionTwo
// optionThree
// optionDescription

function Question(props) {
  return (
    <div className="container">
      <p className="questionText">{props.optionQuestion}</p>
      <div className="row">
        <div className="col">
          <Button
            variant="contained"
            color={props.optionOneStyling}
            onClick={props.onClick}
          >
            {props.optionOne}
          </Button>
        </div>
        <div className="col">
          <Button
            variant="contained"
            color={props.optionTwoStyling}
            onClick={props.onClick}
          >
            {props.optionTwo}
          </Button>
        </div>
        <div className="col">
          <Button
            variant="contained"
            color={props.optionThreeStyling}
            onClick={props.onClick}
          >
            {props.optionThree}
          </Button>
        </div>
      </div>
      <div className="card descriptionBox">
        <p style={props.textStyle}>{props.optionDescription}</p>
      </div>
    </div>
  );
}

export default Question;
